import styled from "styled-components";
import { Link } from "react-router-dom";

export const Column = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const ForgotPasswordText = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0;
`;

export const StyledLink = styled(Link)`
  font-size: inherit;
  font-weight: 500;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
    text-decoration: none;
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
    text-decoration: none;
  }
`;

export const StyledButton = styled.span`
  font-size: inherit;
  font-weight: 500;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
    text-decoration: none;
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
    text-decoration: none;
  }
`;
